export default __webpack_public_path__ + "static/media/WT White.672ee5cc.png";